import { X, Loader2 } from "lucide-react";

export default function Payouthistoryview({ PayoutAccountdata, setpayouthistorymodal, payouthistorymodal, loading }) {



  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={() => setpayouthistorymodal(false)}
    >
      <div
        className="bg-white rounded-xl p-6 w-[90vw] max-w-[1400vw] shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-md font-bold text-indigo-900">Payout File</h2>
          <X
            className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700"
            onClick={() => setpayouthistorymodal(false)}
          />
        </div>

        {/* Scrollable Table */}
        <div className="max-h-64 overflow-y-auto">
          {loading ? (
            <div className="flex justify-center items-center py-10">
              <Loader2 className="h-6 w-6 animate-spin text-indigo-600" />
            </div>
          ) : PayoutAccountdata.length === 0 ? (
            <p className="text-center text-gray-400 text-sm py-10">No entries found</p>
          ) : (
            <table className="w-full border-collapse text-xs">
              <thead className="sticky top-0 z-10">
                <tr className="border-b border-gray-200 bg-[#EFEFEF]">
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Transaction Type</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Amount</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Debit Account No</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">IFSC Code</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Beneficiary Account No</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Beneficiary Name</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold whitespace-nowrap">Client Remarks</th>
                  <th className="px-3 py-2 text-center text-gray-700 font-semibold">Benificiary Remarks</th>
                </tr>
              </thead>
              <tbody>
                {PayoutAccountdata.map((row, i) => (
                  <tr key={i} className="border-b border-gray-100">
                  <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">
{row.TransactionType ?? "-"}
</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{`₹ ${row.Amount ?? "-"}`}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">
  {row.DebitAccountNo ?? "-" }
</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.IFSC ?? "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.BeneficiaryAccountNo != null ? `${row.BeneficiaryAccountNo}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.BeneficiaryName != null ? `${row.BeneficiaryName}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.RemarksClient != null ? `${row.RemarksClient}` : "-"}</td>
                    <td className="px-3 py-2 text-center text-gray-700 whitespace-nowrap">{row.RemarksBeneficiary != null ? `${row.RemarksBeneficiary}` : "-"}</td>

                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}